<template>
  <div>
    <q-dialog v-model="show" @input="(val) => $emit('input', val)" persistent :maximized="true">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-medium" :style="`width: ${modalWidth}; height: ${modalHeight}; max-width: 95vw; max-height: 95vh;`">
        <q-header style="background-color: #3a4155">
          <q-toolbar>
            <q-toolbar-title>
              {{ $gettext("VIEW_INSTALLMENT") }}
            </q-toolbar-title>
            <q-btn id="close-button" v-close-popup flat round dense icon="close" />
          </q-toolbar>
        </q-header>
        <q-page-container class="flex column" style="height: 45.6rem">
          <div class="flex column nav-bar">
            <button class="nav-button" id="parcelas-button" @click="setCardSelected(1)">
              {{ $gettext("PLOTS") }}
            </button>
          </div>
          <div class="flex column nav-bar">
            <button class="nav-button" id="faturas-button" @click="setCardSelected(0)">
              {{ $gettext("FATFATURAS") }}
            </button>
          </div>
          <div class="flex column nav-bar">
            <button class="nav-button" id="summary-button"  @click="setCardSelected(2)">
              {{ $gettext("SUMMARY") }}
            </button>
          </div>
          <div class="main-container">
            <CardDetail
              v-for="card in cards"
              :show="card.show"
              :key="card.number"
            >
              <component :is="card.component" :data="rowData" />
            </CardDetail>
            <div style="padding-bottom: 40px;"></div>
          </div>
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { pageDetail, page } = JtCrud
import { QDialog, Dialog } from 'quasar'
import moment from 'moment'
import CardDetail from './CardDetail.vue'
import Invoices from './cardDetail/Invoices.vue'
import Installment from './cardDetail/Installment.vue'
import Summary from './cardDetail/Summary.vue'
@Component({
  mixins: [page],
  name: 'ServiceRequestDetailModal',
  components: {
    page,
    pageDetail,
    QDialog,
    Dialog,
    CardDetail,
    Summary
  },
  props: {
    show: {
      type: Boolean,
      default: true
    },
    rowData: Object,
    modalWidth: { type: String, default: '200vw' },
    modalHeight: { type: String, default: '120vh' }
  }
})
class ServiceRequestSimpleAgreementDetailModal extends Vue {
  moment = moment;
  cards = [
    { show: false, component: Invoices },
    { show: true, component: Installment },
    { show: false, component: Summary }

  ];

  setCardSelected (index) {
    this.cards.forEach((card, idx) => {
      card.show = idx === index
    })
  }
}

export default ServiceRequestSimpleAgreementDetailModal
</script>
<style lang="stylus" scoped>
.nav-button {
  color: var(--unnamed-color-5f6062);
  height: 60px;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  border: 1px solid var(--unnamed-color-e8e8e8);
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #E8E8E8;
  opacity: 1;
}

.nav-button:hover, .nav-button:focus {
  background-color: #5898aa;
  color: #fff;
}

.nav-button.active {
  background-color: #5898aa;
  color: #fff;
}

.nav-bar {
  width: 17%;
  gap: 20px;
  margin-left: 3%;
  margin-top: 3%;
}

.main-container {
  padding: 34px;
  width: 80%;
  height: 100%;
}
</style>
